// @ts-nocheck
angular.module('messenger')

  .factory('ContactTile', ['AmateurTile', 'Dialog', 'messenger', 'user', '$log', '$translate', 'nicknameFilter', 'smileyFilter', (AmateurTile, Dialog, messenger, user, $log, $translate, nicknameFilter, smileyFilter) => {
    class ContactTile extends AmateurTile {
      load(scope, item) {
        const element = angular.element(this.el);
        let amateurId, dialog;
        if (item instanceof Dialog) {
          amateurId = item.id;
          dialog = item;
          scope.closeable = true;
        } else {
          amateurId = item;
          dialog = messenger.get(item);
          scope.closeable = false;
        }
        scope.dialog = dialog;
        scope.click = () => dialog.show();
        scope.imageFormat = '300';
        this.dontSetBg = true;
        return super.load(scope, amateurId)
          .then(() => {
            this.box.prepend(this.image);
            const onMessage = ev => this.setMessage(scope, ev.detail.message);
            dialog.addEventListener('message', onMessage);
            scope.$watchGroup(['dialog.open', 'dialog.new'], v => {
              element.toggleClass('active', !!v[0]);
              element.toggleClass('inactive', !v[0]);
              element.toggleClass('unread', !!v[1] && !v[0]);
            });
            scope.$on('$destroy', () => {
              dialog.removeEventListener('message', onMessage);
            });

            return dialog.getLastMessage()
              .then(msg => this.setMessage(scope, msg))
              .catch(err => {
                scope.msg = $translate.instant('messenger.writeMe');
                $log.warn('ContactTile', 'Last Message', err);
                if (item instanceof Dialog) {
                  throw err;
                }
              });
          })
          .catch(err => {
            $log.warn('ContactTile', 'Removed Amateur #' + amateurId, err);
            throw err;
          });
      }
      setMessage(scope, msg) {
        scope.msg = '';
        scope.attachment = !!msg.attachment || !!msg.payload.payttachment;
        scope.sent = msg.sender == user.id;
        scope.time = msg.time;
        msg.getMessageText()
          .then(text => scope.msg = smileyFilter(nicknameFilter(text, scope.amateur)))
          .catch(err => $log.warn('ContactTile', err));
      }
      css() {
        return ['contact'];
      }
      hookname() {
        return 'contact';
      }
    }
    return ContactTile;
  }]);
